<template>
    <div>
      <div id="pagination-container">
        <b class="loading" v-if="gridLoading">{{loadingMsg}}<span>.</span><span>.</span><span>.</span></b>
        <b class="loadError" v-if="gridLoadError">{{gridLoadErrorMsg}}</b>
        <span
          @click="showOptions"
          class="pagination-label"
        >
          {{componentInitialItem}} - {{componentLastItem}} of {{ totalResult }}
        </span>
        <span :class="leftArrowClass" @click="decrementPage">{{ leftArrow }}</span>
        <span :class="rightArrowClass" @click="incrementPage">{{ rightArrow }}</span>
        <criteria-list id="checklist"
          :currentOptions="options"
          v-show="dropDownOpened"
          @setItemsPerPage="setItemsPerPage"
        ></criteria-list>
      </div>
    </div>
</template>
<script>
import CriteriaList from './Criteria/content/CriteriaOptionList'

import _ from 'lodash'
export default {
  name: 'PaginationControl',
  components: {
    'criteria-list': CriteriaList
  },
  props: {
    currentPage: {
      default: 1,
      type: Number
    },
    totalResult: {
      default: 0,
      type: Number
    },
    itemsPerPage: {
      default: 50,
      type: Number
    }
  },
  data () {
    return {
      componentCurrentPage: this.currentPage,
      totalItemsPerPage: this.itemsPerPage,
      dropDownOpened: false,
      loadingMsg: this.$i18n.t('DocumentGrid.loadingGridMessage'),
      gridLoadErrorMsg: this.$i18n.t('DocumentGrid.LoadingErrorMessage'),
      leftArrow: '<',
      rightArrow: '>',
      options: [
        {
          Value: 10,
          Selected: false
        },
        {
          Value: 50,
          Selected: true
        },
        {
          Value: 100,
          Selected: false
        },
        {
          Value: 250,
          Selected: false
        },
        {
          Value: 500,
          Selected: false
        },
        {
          Value: 1000,
          Selected: false
        }
      ]
    }
  },
  created () {
    this.options.forEach(item => {
      if (item.Value === this.itemsPerPage) {
        item.Selected = true
      } else {
        item.Selected = false
      }
    })
  },
  computed: {
    canClickRight () {
      return this.componentCurrentPage < this.totalPages
    },
    canClickLeft () {
      return this.componentCurrentPage > 1
    },
    rightArrowClass () {
      return this.canClickRight ? 'page-control active' : 'page-control unactive'
    },
    leftArrowClass () {
      return this.canClickLeft ? 'page-control active' : 'page-control unactive'
    },
    componentInitialItem () {
      if (this.totalResult === 0) return 0
      return (this.componentCurrentPage - 1) * this.totalItemsPerPage + 1
    },
    componentLastItem () {
      let base = (this.componentCurrentPage - 1) * this.totalItemsPerPage
      let rem = this.totalResult - base
      if (rem > this.totalItemsPerPage) { return base + this.totalItemsPerPage }
      return base + rem
    },
    totalPages () {
      let pages = Math.trunc(this.totalResult / this.totalItemsPerPage)
      if (this.totalResult % this.totalItemsPerPage !== 0) { return pages + 1 }
      return pages
    },
    gridLoading () {
      return this.$store.getters.getGridLoadingState
    },
    gridLoadError () {
      return this.$store.getters.getGridLoadingError
    }
  },
  watch: {
    currentPage () {
      this.componentCurrentPage = this.currentPage
    }
  },
  methods: {
    decrementPage () {
      if (this.canClickLeft) {
        this.componentCurrentPage -= 1
        this.updatePage(this, this.componentCurrentPage)
      }
    },
    incrementPage () {
      if (this.canClickRight) {
        this.componentCurrentPage += 1
        this.updatePage(this, this.componentCurrentPage)
      }
    },

    updatePage: _.debounce((self, pageNumber) => {
      self.$emit('pageChanged', pageNumber)
    }, 500),

    showOptions () {
      this.dropDownOpened = !this.dropDownOpened
    },
    setItemsPerPage (value) {
      this.dropDownOpened = false
      this.totalItemsPerPage = value
      this.componentCurrentPage = 1
      this.$emit('setItemsPerPage', value)
    }
  }
}
</script>
<style scoped>
.pagination-label {
  top: 1px;
  padding: 10px;
  margin-right: 20px;
  border-radius: 5px;
}
.pagination-label:hover {
  cursor: pointer;
  box-shadow: 0 0 3px gray;
}
.pagination-label::selection {
    color: black;
    background: white;
}
/* For Mozilla Firefox */
.pagination-label::-moz-selection {
    color: black;
    background: white;
}
#pagination-container {
  padding: 15px;
}
.page-control {
  padding: 10px;
}
.page-control::selection {
    color: black;
    background: white;
}
/* For Mozilla Firefox */
.page-control::-moz-selection {
    color: black;
    background: white;
}
.unactive {
  color: lightgray;
}
.active:hover {
  box-shadow: 0 0 3px gray;
  border-radius: 5px;
  cursor: pointer;
}

#pagination-container::selection {
    color: black;
    background: white;
}
/* For Mozilla Firefox */
#pagination-container::-moz-selection {
    color: black;
    background: white;
}
.loading {
  padding: 10px;
  background-color: lightgoldenrodyellow;
  color: black;
}
@keyframes blink {
    0% {
      opacity: .2;
    }
    20% {
      opacity: 1;
    }
    100% {
      opacity: .2;
    }
}
.loading span {
    animation-name: blink;
    animation-duration: 1.4s;
    animation-iteration-count: infinite;
    animation-fill-mode: both;
}
.loading span:nth-child(2) {
    animation-delay: .2s;
}
.loading span:nth-child(3) {
    animation-delay: .4s;
}
.loadError {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/grid/paginationControl.vue